module.exports = __webpack_public_path__ + "static/media/new-york-lamp.04da8779.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/new-york-lamp.svg
// module id = 98
// module chunks = 0